import { ReactNode, useCallback, useRef, useState } from 'react'

import { DelayedOperationContext, TOperation } from './context/OperationContext'

interface IDelayedOperationController {
  children: ReactNode
}

export const DelayedOperationController = ({ children }: IDelayedOperationController) => {
  const [inProgress, setInProgress] = useState<boolean>(false)
  const [hasRegistredOperations, setHasRegistredOperations] = useState<boolean>(false)
  const operationsRef = useRef<TOperation[]>([])

  const addOperation = useCallback((operation: TOperation) => {
    operationsRef.current.push(operation)
    setHasRegistredOperations(true)
    return () => {
      const newOperationsList = operationsRef.current.filter((el) => el !== operation)
      setHasRegistredOperations(!!newOperationsList.length)
      operationsRef.current = newOperationsList
    }
  }, [])

  const finishOperations = useCallback(() => {
    setInProgress(true)
    const promises = operationsRef.current.map((operation) => {
      return operation()
    })
    return new Promise<void>((resolve, reject) => {
      Promise.all(promises)
        .then(() => resolve())
        .catch((err) => {
          reject(err)
        })
        .finally(() => setInProgress(false))
    })
  }, [])

  const contextValue = {
    addOperation,
    finishOperations,
    finishOperationsInProgress: inProgress,
    hasRegistredOperations,
  }

  return (
    <DelayedOperationContext.Provider value={contextValue}>
      {children}
    </DelayedOperationContext.Provider>
  )
}
